import { Drawer } from "antd";
import PropTypes from "prop-types";
import React, { ReactElement, useState } from "react";
import AddBtn from "../common/AddBtn";
import AddKeyword from "./AddKeyword";

const TopHeading = ({ total, refetch }: any): ReactElement => {
  const [visible, setVisible] = useState<boolean>(false);

  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
    refetch();
  };

  return (
    <div className="top-heading-products top-heading-content">
      <div className="container-fluid">
        <div className="row mb-3 d-flex-sb">
          <div className="col-lg-4 col-md-4 no-padding">
            <div className="page-heading-content">
              <h2 className="d-flex-l d-flex-nowrap d-flex-base">
                <b className="nowrap" style={{ whiteSpace: "nowrap" }}>
                  Keyword List{" "}
                </b>
                <span className="d-flex-l ml-1">{total || 0} Keyword(s)</span>
              </h2>
            </div>
          </div>
          <div className="single-button d-flex">
            <AddBtn onClick={showDrawer} />
          </div>
          <Drawer
            title="Add Keyword"
            width={500}
            onClose={onClose}
            visible={!!visible}
            bodyStyle={{ paddingBottom: 0 }}
            footer={
              <div
                style={{
                  textAlign: "left",
                }}
              ></div>
            }
          >
            <AddKeyword onCloseMethod={onClose} />
          </Drawer>
        </div>
      </div>
    </div>
  );
};

TopHeading.propTypes = {
  ProductId: PropTypes.string,
  GetStatus: PropTypes.string,
  GetPrime: PropTypes.string,
  GetFlagship: PropTypes.string,
  GetRocket: PropTypes.string,
  name: PropTypes.string,
};

export default React.memo(TopHeading);
